"use client";

import { useSearchParams } from "next/navigation";
import RegisterForm from "./RegisterForm";
import { Stack } from "@/components/structure/Stack";
import { Suspense } from "react";

function SignUpContent() {
  const searchParams = useSearchParams();
  const plan = searchParams.get("plan"); // "pro" or null
  const redirect = searchParams.get("redirect");

  return (
    <Stack gap="20" className="mt-40">
      <div className="flex w-screen items-center justify-center pb-20">
        <div className="z-10 w-full max-w-lg overflow-hidden border border-black">
          <div className="flex flex-col items-center justify-center space-y-3 px-4 py-6 pt-8 text-center sm:px-16">
            <h2 className="type-2 font-black uppercase">
              Create Your Thinknado Account
            </h2>
            {plan === "pro" && (
              <div className="bg-pink text-white px-4 py-2 rounded-think-sm text-sm font-bold">
                50% OFF - Lock in $5/month forever!
              </div>
            )}
          </div>
          <RegisterForm plan={plan} redirectTo={redirect} />
        </div>
      </div>
    </Stack>
  );
}

export default function Login() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <SignUpContent />
    </Suspense>
  );
}
